export const blogData = [
  {
    id: 'understandingInstantFlows',
    title: 'Understanding InstantFlows: How We Generate Reliable AI Market Research',
    image: 'understanding-instantflows.jpeg',
    category: 'AI Research Methodology',
    date: '16 July 2025',
    authors: ['George Gittins']
  },
  {
    id: 'aiHumanSurvey', 
    title: 'The Integration of AI and Human Expertise in Survey Design',
    image: 'ai-human-survey.jpeg',
    category: 'AI and Human Expertise',
    date: '20 August 2024',
  },
  {
    id: 'aiMarketResearch', 
    title: 'The Rise of AI in Market Research: Revolutionizing Insights',
    image: 'ai-market-research.jpeg',
    category: 'AI in Market Research',
    date: '22 September 2024',

  },
  {
    id: 'syntheticData',
    title: 'Synthetic Data: The Future of Privacy-Conscious Market Research',
    image: 'synthetic-data.jpeg',
    category: 'Privacy and Data Protection',
    date: '13 October 2024',
  },
  {
    id: 'instantflowsAiChallenges',
    title: 'InstantFlows: Tackling AI Challenges with Trusted Insights and Solutions',
    image: 'instantflows-ai-challenges.jpeg',
    category: 'AI Solutions',
    date: '13 November 2024',
    authors: ['George Gittins', 'Priscille Niakale'] // Optional
  },
  {
    id: 'realTimeInsights',
    title: 'Real-Time Insights: The Power of AI-Simulated Responses',
    image: 'real-time-insights.jpeg',
    category: 'Real-Time Insights',
    date: '02 December 2024',
  },
  {
    id: 'revolutionizingMarketResearch',
    title: 'White Paper: Revolutionizing Market Research',
    image: 'revolutionizing-market-research.jpeg',
    category: 'Synthetic Data and Generative AI',
    date: '01 July 2025',
  },
];